
import { motion } from 'framer-motion';

export const BankersVisuals = () => {
    return (
        <div className="w-full h-full bg-white relative overflow-hidden flex flex-col items-center justify-center p-8 font-jakarta">
            <div className="relative w-full max-w-[540px] shadow-2xl rounded-xl border border-gray-200 bg-white overflow-hidden p-8">

                <div className="absolute top-0 right-0 p-6">
                    <div className="bg-red-50 text-red-700 border border-red-100 text-[10px] font-bold px-3 py-1 rounded uppercase tracking-wider">Confidential</div>
                </div>

                {/* Grid Layout Layout */}
                <div className="space-y-8">
                    {/* Header */}
                    <div className="space-y-4 border-b border-gray-100 pb-4">
                        <div>
                            <h3 className="text-xl font-bold text-gray-900 font-serif">Project Skylark</h3>
                            <p className="text-xs text-gray-500 mt-1">Confidential Information Memorandum</p>
                        </div>
                    </div>

                    {/* Financial Blocks */}
                    <div className="grid grid-cols-2 gap-8">
                        {/* Market Analysis Block */}
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="col-span-1 space-y-3"
                        >
                            <div className="text-[10px] font-bold text-gray-900 uppercase tracking-wide border-b border-gray-100 pb-1">Valuation Summary</div>
                            <div className="bg-gray-50 p-4 rounded-sm border border-gray-100 flex items-end justify-between h-32">
                                {[40, 65, 45, 80, 55, 90].map((h, i) => (
                                    <div key={i} className="flex flex-col items-center gap-1 w-full">
                                        <motion.div
                                            initial={{ height: 0 }}
                                            animate={{ height: `${h}%` }}
                                            transition={{ delay: 0.2 + (i * 0.1), duration: 0.5 }}
                                            className="w-3 bg-[#0f172a] rounded-sm"
                                            style={{ opacity: 0.6 + (i * 0.05) }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </motion.div>

                        {/* Stats Block */}
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                            className="col-span-1 space-y-4"
                        >
                            <div className="text-[10px] font-bold text-gray-900 uppercase tracking-wide border-b border-gray-100 pb-1">Key Financials</div>
                            <div className="space-y-3">
                                {[
                                    { label: 'Revenue', val: '$52.4M', change: '+24%' },
                                    { label: 'EBITDA', val: '$12.8M', change: '+18%' },
                                    { label: 'Margin', val: '24.2%', change: '+2.1%' }
                                ].map((item, i) => (
                                    <div key={i} className="flex justify-between items-center py-1">
                                        <span className="text-xs font-medium text-gray-500">{item.label}</span>
                                        <div className="text-right">
                                            <div className="text-sm font-bold text-gray-900">{item.val}</div>
                                            <div className="text-[9px] text-green-600 font-bold">{item.change}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    </div>

                    {/* Text Analysis */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.6 }}
                        className="space-y-3 pt-2 bg-blue-50/30 p-4 rounded-lg border border-blue-50"
                    >
                        <div className="text-[10px] font-bold text-blue-900 uppercase tracking-wide">Investment Highlights</div>
                        <div className="space-y-2">
                            <div className="h-1.5 bg-gray-200 rounded-full w-full" />
                            <div className="h-1.5 bg-gray-200 rounded-full w-11/12" />
                            <div className="h-1.5 bg-gray-200 rounded-full w-4/6" />
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* Background Layer to simulate "Book" or "Deck" thickness */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[550px] h-[calc(100%+8px)] bg-gray-100 rounded-xl -z-10 transform translate-y-3 border border-gray-200 shadow-sm" />
        </div>
    );
};
